import axiosInstance from "../../services/api.service";
import constants from "../../constants/constants";

const ENDPOINTORIGIN = "YearAllocationSetting/";

const getAll = async () =>
    await axiosInstance.get(ENDPOINTORIGIN + 'GetAll', constants.REQUIRE_INTERCEPTORS);

const getByYear = async (year) =>
    await axiosInstance.get(ENDPOINTORIGIN + 'GetByYear/' + year, constants.REQUIRE_INTERCEPTORS);

const getById = async (id) =>
    await axiosInstance.get(ENDPOINTORIGIN + 'GetById/' + id, constants.REQUIRE_INTERCEPTORS);

const getOrCreateForYear = async (year) =>
    await axiosInstance.get(ENDPOINTORIGIN + 'GetOrCreateForYear/' + year, constants.REQUIRE_INTERCEPTORS);

const save = async (dto) =>
    await axiosInstance.post(ENDPOINTORIGIN + 'Save', dto, constants.REQUIRE_INTERCEPTORS);

const deleteSetting = async (id) =>
    await axiosInstance.delete(ENDPOINTORIGIN + 'Delete/' + id, constants.REQUIRE_INTERCEPTORS);

export {
    getAll,
    getByYear,
    getById,
    getOrCreateForYear,
    save,
    deleteSetting
};
